import yaml from 'js-yaml';

/**
 * Parses the provided string content to an object.
 *
 * @param {string} content - the string content to parse
 * @returns {string | object | undefined}
 */
export function parseYaml(content: string): string | object | undefined {
  return yaml.safeLoad(content);
}
